import { createContext } from 'react';

import type { MelwaysInformation } from './melways-info.ts';

export const MelwaysContext = createContext<MelwaysInformation | null>(null);
